// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bot-logs-page {
  padding: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
}

.bot-logs-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1.25rem;
  gap: 1rem;
  flex-wrap: wrap;
}

.bot-logs-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.25rem;
}

.bot-logs-subtitle {
  color: #718096;
  margin: 0;
  font-size: 0.9rem;
}

.bot-logs-autorefresh {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #4b5563;
  cursor: pointer;
  white-space: nowrap;
  margin-top: 0.5rem;
}

/* ── Filters ───────────────────────────────────────────── */
.bot-logs-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
}

.bot-logs-filters select,
.bot-logs-filters input[type="text"],
.bot-logs-filters input[type="date"] {
  padding: 0.45rem 0.6rem;
  border: 1px solid #d1d5db;
  border-radius: 7px;
  font-size: 0.875rem;
  background: white;
  color: #374151;
  outline: none;
}
.bot-logs-filters select:focus,
.bot-logs-filters input:focus { border-color: #3b82f6; }

.bot-logs-filters input[type="text"] { min-width: 130px; }

.bot-logs-sep { color: #9ca3af; font-size: 0.85rem; }

.btn-search {
  padding: 0.45rem 1rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 7px;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}
.btn-search:hover:not(:disabled) { background: #2563eb; }
.btn-search:disabled { opacity: 0.6; cursor: not-allowed; }

.btn-refresh {
  padding: 0.45rem 0.6rem;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 7px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.15s;
}
.btn-refresh:hover { background: #f3f4f6; }

/* ── Stats ─────────────────────────────────────────────── */
.bot-logs-stats {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: #6b7280;
  margin-bottom: 0.75rem;
  padding: 0 0.25rem;
}

.bot-logs-error {
  background: #fef2f2;
  border: 1px solid #fca5a5;
  color: #dc2626;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

/* ── Table ─────────────────────────────────────────────── */
.bot-logs-table-wrap {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.bot-logs-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.bot-logs-table thead {
  background: #f3f4f6;
  position: sticky;
  top: 0;
}

.bot-logs-table th {
  padding: 0.65rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
  white-space: nowrap;
}

.bot-logs-table td {
  padding: 0.55rem 0.75rem;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: top;
}

.bot-logs-row--success td { border-left: 3px solid #10b981; }
.bot-logs-row--error   td { border-left: 3px solid #ef4444; }
.bot-logs-row--warning td { border-left: 3px solid #f59e0b; }
.bot-logs-row--info    td { border-left: 3px solid #3b82f6; }

.bot-logs-row:hover td { background: #f9fafb; }

.bot-logs-time   { white-space: nowrap; color: #6b7280; font-size: 0.8rem; }
.bot-logs-config { white-space: nowrap; font-weight: 500; color: #374151; }
.bot-logs-symbol code {
  background: #f3f4f6;
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #1d4ed8;
}

.bot-logs-message { max-width: 500px; line-height: 1.4; color: #1f2937; }

.bot-logs-badge {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 99px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.btn-details {
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.75rem;
  padding: 0.15rem 0.4rem;
  color: #4b5563;
}
.btn-details:hover { background: #e5e7eb; }

.bot-logs-details {
  margin-top: 0.4rem;
  font-size: 0.75rem;
  background: #1f2937;
  color: #e5e7eb;
  padding: 0.6rem;
  border-radius: 6px;
  overflow: auto;
  max-width: 320px;
  max-height: 200px;
  white-space: pre-wrap;
  word-break: break-all;
}

.bot-logs-empty {
  text-align: center;
  color: #9ca3af;
  padding: 2rem !important;
  font-style: italic;
}

/* ── Pagination ────────────────────────────────────────── */
.bot-logs-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 1.25rem;
  font-size: 0.9rem;
  color: #4b5563;
}

.bot-logs-pagination button {
  padding: 0.4rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 7px;
  background: white;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background 0.15s;
}
.bot-logs-pagination button:hover:not(:disabled) { background: #f3f4f6; }
.bot-logs-pagination button:disabled { opacity: 0.4; cursor: not-allowed; }
`, "",{"version":3,"sources":["webpack://./src/pages/BotLogs.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;AACA;gCACgC,qBAAqB,EAAE;;AAEvD,uCAAuC,gBAAgB,EAAE;;AAEzD,gBAAgB,cAAc,EAAE,kBAAkB,EAAE;;AAEpD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;AACA,mCAAmC,mBAAmB,EAAE;AACxD,uBAAuB,YAAY,EAAE,mBAAmB,EAAE;;AAE1D;EACE,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;AACA,qBAAqB,mBAAmB,EAAE;;AAE1C,6DAA6D;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,4BAA4B,8BAA8B,EAAE;AAC5D,4BAA4B,8BAA8B,EAAE;AAC5D,4BAA4B,8BAA8B,EAAE;AAC5D,4BAA4B,8BAA8B,EAAE;;AAE5D,yBAAyB,mBAAmB,EAAE;;AAE9C,mBAAmB,mBAAmB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC3E,mBAAmB,mBAAmB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC1E;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAExE;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;AACA,qBAAqB,mBAAmB,EAAE;;AAE1C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,mDAAmD,mBAAmB,EAAE;AACxE,uCAAuC,YAAY,EAAE,mBAAmB,EAAE","sourcesContent":[".bot-logs-page {\n  padding: 1.5rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.bot-logs-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 1.25rem;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.bot-logs-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0 0 0.25rem;\n}\n\n.bot-logs-subtitle {\n  color: #718096;\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.bot-logs-autorefresh {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  color: #4b5563;\n  cursor: pointer;\n  white-space: nowrap;\n  margin-top: 0.5rem;\n}\n\n/* ── Filters ───────────────────────────────────────────── */\n.bot-logs-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n}\n\n.bot-logs-filters select,\n.bot-logs-filters input[type=\"text\"],\n.bot-logs-filters input[type=\"date\"] {\n  padding: 0.45rem 0.6rem;\n  border: 1px solid #d1d5db;\n  border-radius: 7px;\n  font-size: 0.875rem;\n  background: white;\n  color: #374151;\n  outline: none;\n}\n.bot-logs-filters select:focus,\n.bot-logs-filters input:focus { border-color: #3b82f6; }\n\n.bot-logs-filters input[type=\"text\"] { min-width: 130px; }\n\n.bot-logs-sep { color: #9ca3af; font-size: 0.85rem; }\n\n.btn-search {\n  padding: 0.45rem 1rem;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 7px;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: background 0.15s;\n  white-space: nowrap;\n}\n.btn-search:hover:not(:disabled) { background: #2563eb; }\n.btn-search:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.btn-refresh {\n  padding: 0.45rem 0.6rem;\n  background: white;\n  border: 1px solid #d1d5db;\n  border-radius: 7px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.btn-refresh:hover { background: #f3f4f6; }\n\n/* ── Stats ─────────────────────────────────────────────── */\n.bot-logs-stats {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.85rem;\n  color: #6b7280;\n  margin-bottom: 0.75rem;\n  padding: 0 0.25rem;\n}\n\n.bot-logs-error {\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  color: #dc2626;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n}\n\n/* ── Table ─────────────────────────────────────────────── */\n.bot-logs-table-wrap {\n  overflow-x: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n}\n\n.bot-logs-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.bot-logs-table thead {\n  background: #f3f4f6;\n  position: sticky;\n  top: 0;\n}\n\n.bot-logs-table th {\n  padding: 0.65rem 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 2px solid #e5e7eb;\n  white-space: nowrap;\n}\n\n.bot-logs-table td {\n  padding: 0.55rem 0.75rem;\n  border-bottom: 1px solid #f3f4f6;\n  vertical-align: top;\n}\n\n.bot-logs-row--success td { border-left: 3px solid #10b981; }\n.bot-logs-row--error   td { border-left: 3px solid #ef4444; }\n.bot-logs-row--warning td { border-left: 3px solid #f59e0b; }\n.bot-logs-row--info    td { border-left: 3px solid #3b82f6; }\n\n.bot-logs-row:hover td { background: #f9fafb; }\n\n.bot-logs-time   { white-space: nowrap; color: #6b7280; font-size: 0.8rem; }\n.bot-logs-config { white-space: nowrap; font-weight: 500; color: #374151; }\n.bot-logs-symbol code {\n  background: #f3f4f6;\n  padding: 0.15rem 0.4rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #1d4ed8;\n}\n\n.bot-logs-message { max-width: 500px; line-height: 1.4; color: #1f2937; }\n\n.bot-logs-badge {\n  display: inline-block;\n  padding: 0.2rem 0.5rem;\n  border-radius: 99px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.btn-details {\n  background: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.75rem;\n  padding: 0.15rem 0.4rem;\n  color: #4b5563;\n}\n.btn-details:hover { background: #e5e7eb; }\n\n.bot-logs-details {\n  margin-top: 0.4rem;\n  font-size: 0.75rem;\n  background: #1f2937;\n  color: #e5e7eb;\n  padding: 0.6rem;\n  border-radius: 6px;\n  overflow: auto;\n  max-width: 320px;\n  max-height: 200px;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n.bot-logs-empty {\n  text-align: center;\n  color: #9ca3af;\n  padding: 2rem !important;\n  font-style: italic;\n}\n\n/* ── Pagination ────────────────────────────────────────── */\n.bot-logs-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1.5rem;\n  margin-top: 1.25rem;\n  font-size: 0.9rem;\n  color: #4b5563;\n}\n\n.bot-logs-pagination button {\n  padding: 0.4rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 7px;\n  background: white;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: background 0.15s;\n}\n.bot-logs-pagination button:hover:not(:disabled) { background: #f3f4f6; }\n.bot-logs-pagination button:disabled { opacity: 0.4; cursor: not-allowed; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
